<template>
<div class="quote-aside-group mg-b-sm" v-if="pcblist">
	<h4 class="f-bold fc-gn pd-t-bs pd-b-sm">{{LANG.pcb_price}}</h4>
	<div class="quote-aside_price">
		<div class="thead">
			<div class="tr">
				<div class="th pd-l-lg">
					{{LANG.build_time}}
				</div>
				<div class="th">
					{{LANG.qty}}
				</div>
				<div class="th">
					<template v-if="deltimes[0].sale !== undefined">
						{{LANG.sale_price}}
					</template>
					<template v-else>
						{{LANG.price}}
					</template>
				</div>
			</div>
		</div>
		<div class="tbody">
			<template v-for="(v,i) in deltimes">				
				<div class="tr" :class="{active:deltime === v.name}" @click="checkPrice(v)"  :key="i">
					<div class="td">
						<check-box v-model="deltime" class="vlm mg-l-xs" :val="v.name" :radio="true"  shape="cir"></check-box>
						<span class="vlm mg-l-xs" v-text="fillterDeltime(v.name)"></span>
						<i v-if="hasUrgent(v.name)" class="mg-l-xs icon vlm fc-tips">&#xe8c5;</i>
					</div>
					<div class="td">{{showCount(v)}}</div>
					<div class="td">
						<span v-if="v.sale!==undefined" class="original-price">${{v.pcb_total_original}}</span>
						{{'$' + (valuation.outbound == 1?'?':(v.sale!==undefined? v.sale :  v.total))}}
						<!-- <img v-if="v.sale!==undefined" src="//static.nextpcb.com/images/newCenter/sale.png?v=3.128" alt="">						 -->
					</div>
				</div>
			</template>
		</div>
		<!-- <p class="fc-quotetips pd-t-xs fs-sm pd-b-sm pd-t-sm">
			<img src="//static.nextpcb.com/images/tipIcon.png" style="width: 16px; float: left; margin-right: 3px;">
			<span style="display: block; overflow: hidden;" v-text="LANG.final_price_tips"></span>
		</p> -->

		<p v-if="isChoseZero"   class="pd-t-xs fs-sm logo-0-tip">
			<!-- <img src="//static.nextpcb.com/images/tipIcon.png" style="width: 16px;float: left;margin-right: 3px; " /> -->
			We will print NEXTPCB logo on your PCBs if you choose $0.
		</p>
		<template v-else>
			<p v-if="isOutbound" style="color: #c7a572;"   class="pd-t-xs fs-sm pd-b-sm pd-t-sm">
				<img src="//static.nextpcb.com/images/tipIcon.png" style="width: 16px;float: left;margin-right: 3px;" />
				{{LANG.final_price_tips}}</p>
			<!-- <p v-else style="color: #c7a572;"   class="pd-t-xs fs-sm pd-b-sm pd-t-sm">
				<img src="//static.nextpcb.com/images/tipIcon.png" style="width: 16px;float: left;margin-right: 3px;" />
				<span style="display: block;overflow: hidden;">
					{{LANG.quote_result_tips1}}
				</span>
			</p> -->
		</template>


		<div class="quote-aside_price-weight pd-tb-sm">
			<span class="lt">{{LANG.area}}: {{$tools.keepDecimal(calcArea,4) || $tools.keepDecimal(area,4)}}  ㎡</span>
			<!-- <span class="fl-gt" v-if="pcblist">{{LANG.weight}}: {{pcblist.weight}} kg</span> -->
		</div>
	</div>
</div>
</template>

<script>
import checkbox from '@/_module/checkbox/index.vue'
export default {
	data(){
		return {
			deltime: "",
			calcArea: 0,
			recordClickDeltime: false // 判断是否点击切换交期
		}
	},
	mounted(){
		this.setDefaultDeltime();
		this.$bus.$on('pcbCalcArea', (calcArea) => {
			console.log(80, calcArea)
			this.calcArea = calcArea
		})
	},
	computed:{
		valuation(){
			return this.$store.getters.getQuoteValuation;
		},
		pcblist(){
			if(this.valuation && this.valuation.list){
				if(this.valuation.list.pcb){
					return this.valuation.list.pcb;
				}
			}
			return null;
		},
		area(){
			if(this.pcblist){
				return this.pcblist.area /10000;
			}
			return 0;
		},
		deltimes(){
			if(this.pcblist){
				return this.valuation.list.pcb.suggest.deltime;
			}
			return [];
		},
		bcount(){
			let stay = this.$store.state.quote.stay,relation = this.$store.state.quote.relation;
			//pcb材質count 獲取數量
			/*
			如果stay=pcb 或則 relation = pcb
			*/
			/*
			根據頁面stay 以及關聯情況
			如果stay==fpc 或則 relation = fpc

			*/
			if(stay === "pcb" || relation === "pcb"){
				if(this.$store.getters.getQuotepcb_params){
					return this.$store.getters.getQuotepcb_params.bcount;
				}
			}
			if(stay === "rfpc" || relation === "rfpc"){
				if(this.$store.getters.getQuoterfpc_params){
					return this.$store.getters.getQuoterfpc_params.bcount;
				}
			}
			if(stay === "fpc" || relation === "fpc"){
				if(this.$store.getters.getQuotefpc_params){
					return this.$store.getters.getQuotefpc_params.bcount;
				}
			}

			return 0;
		},
		isChoseZero(){
			let isZero = false;
			this.$tools.inArray(this.deltime,this.deltimes,"name",(v)=>{
				if(v.activity_code === "new_customer_first_free"){
					isZero = true;
				}
			});
			return isZero;
		},
		isOutbound(){
			if(this.valuation.list && this.valuation.list.pcb){
				return this.valuation.list.pcb.outbound;
			}
			return false;
		},
		showCount(){
			return function(item){
				return item?.pcs_count || this.bcount()
			}
		}
	},
	methods:{
		fillterDeltime(v){
			let str = v.split("_")[0];
			if(str && str.indexOf('urgent')>=0){
				return str.replace('urgent','');
			}
			return str;
		},
		hasUrgent(v){
			if(v && v.indexOf('urgent')>=0){
				return true;
			}
			return false;
		},
		setDefaultDeltime(bc){
			console.log(173, this.deltimes, bc, this.deltime)
			if(this.deltimes && this.deltimes.length){
				for(let i in this.deltimes) {
					// 默认普通交期
					if(!this.deltimes[i].name.includes('urgent')) {
						this.deltime = this.deltimes[i].name;
						if(typeof bc === "function"){
							bc(this.deltimes[i])
						}
						// 拿到交期和活动code后重新计价
						// this.$store.dispatch("calcQuoteValuation");
						return
					}
				}
				this.deltime = this.deltimes[0].name;
				if(typeof bc === "function"){
					bc(this.deltimes[0])
				}
				// this.$store.dispatch("calcQuoteValuation");
			}
		},
		checkPrice(v){
			console.log(189, v, this.deltime)
			if(v.name !== this.deltime){
				this.recordClickDeltime = true
				this.deltime = v.name;
				this.$store.commit("setQuoteParams",{value:v.active,key:"aside_param.active"});
				this.$store.commit("setQuoteParams",{value:v.activity_code,key:"aside_param.activity_code"});
				// this.$store.commit("setQuoteParams",{value: 1,key:"pcb_params.show_step"});		
				let promise = this.$store.dispatch("calcQuoteValuation");
				promise.then(res=>{
					this.$store.dispatch('getStepPrice')
				})
			} else {
				this.recordClickDeltime = false
			}
		},
		countDeltimes(v){
			if(v.length){
				let deltimeitem;
				// 当前选中的交期取接口返回的
				deltimeitem = this.deltimes.find(item => item.name.split('_')[0] == this.valuation.list.pcb.deltime)

				console.log(226, deltimeitem, this.deltime, this.deltimes)
				this.deltime = deltimeitem.name;
				this.$store.commit("setQuoteParams",{value:deltimeitem.active,key:"aside_param.active"});
				this.$store.commit("setQuoteParams",{value:deltimeitem.activity_code,key:"aside_param.activity_code"});
				this.$emit("checkpcbdeltime",deltimeitem);
			}
		}
	},
	watch:{
		// isChoseZero(v){
			// let firstStr = this.$store.state.quote.pcbFirstTips;
			// if(v){
			// 	this.$store.commit("setQuoteOneParams",{value:firstStr,key:"hasFirstTips"});
			// }else{
			// 	this.$store.commit("setQuoteOneParams",{value:"",key:"hasFirstTips"});
			// }
		// },
		deltime(v){	
			console.log(257, this.deltime)
			//提交参数修改
			this.$store.commit("setQuoteParams",{value:v.split("_")[0],key:"aside_param.deltime"});
			//触发判断是否为特价判断
			let rst;
				this.$tools.inArray(v,this.deltimes,"name",(item)=>{
					rst = (item.sale !== undefined);					
				})
			console.log(241, this.deltimes, rst)
			// this.countDeltimes(this.deltimes);
			// 更新交期值
			const currentDeltime = this.deltimes.find(item => item.name === v)
			if(currentDeltime) {
				this.$store.commit("setQuoteParams",{value:currentDeltime.active || '',key:"aside_param.active"});
				this.$store.commit("setQuoteParams",{value:currentDeltime.activity_code || '',key:"aside_param.activity_code"});
				this.$emit("checkpcbdeltime",currentDeltime);
			}
			this.$emit("issales",rst);
		},
		deltimes(v, oldVal){
			v.map(item => item.active = '')
			oldVal.map(item => item.active = '')
			console.log(273, this.recordClickDeltime, v, oldVal, JSON.stringify(v) == JSON.stringify(oldVal))
			// 不是点击切换交期则需要重新请求计价接口
			if(this.recordClickDeltime) {
				const currentDeltime = this.deltimes.find(item => item.name === this.deltime)
				console.log(277, currentDeltime)
				if(currentDeltime) {
					this.$store.commit("setQuoteParams",{value:currentDeltime.active || '',key:"aside_param.active"});
					this.$store.commit("setQuoteParams",{value:currentDeltime.activity_code || '',key:"aside_param.activity_code"});
					this.$emit("checkpcbdeltime",currentDeltime);
				}
				this.recordClickDeltime = false
			} else {
				this.countDeltimes(v)
			}
		}
	},
	components: {
		'check-box':checkbox
	},
	beforeDestroy() {
		this.$bus.$off('pcbCalcArea')
	}
}
</script>
